module.exports = __webpack_public_path__ + "img/lp.5d76d490.jpg";